import CalendarIcon from "../../assets/svgs/calendar.svg";
import styles from "./TaskHeaderExit.module.css";

const formatDiaMesES = (iso) => {
    if (!iso) return "";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return new Intl.DateTimeFormat("es-ES", {
        day: "numeric",
        month: "long",
    }).format(d);
};

const TaskHeaderExit = ({ selectedDate, isMobile = false }) => {
    const fechaCorta = formatDiaMesES(selectedDate);

    return (
        <div className={styles.headerWrapper}>
            <div className={styles.headerContainer}>
                <img
                    src={CalendarIcon}
                    alt="Calendario"
                    className={styles.calendarIcon}
                />
                <h2
                    className={`${styles.headerTitle} ${isMobile ? styles.headerTitleMobile : ""
                        }`}
                >
                    <span className={styles.titlePrefix}>Coberturas </span>
                    <span className={styles.date}>{fechaCorta || "—"}</span>
                </h2>
            </div>
        </div>
    );
};

export default TaskHeaderExit;
